{
    "details": {
        "file_details": "Détails du dossier",
        "history": "Historique"
    },
    "keys": {
        "file_number": "N° dossier",
        "total_amount": "Montant",
        "initial_amount": "Montant initial",
        "final_amount": "Montant final",
        "status": "Statut",
        "label": "Libellé TPE",
        "currency": "Devise",
        "bank_code": "Code banque",
        "pan": "N° de carte",
        "opening_date": "Ouverture",
        "closing_date": "Clôture",
        "expiration_date": "Expir. Dossier",
        "card_type": "Émetteur",
        "rank": "Rang",
        "contract": "Contrat"
    },
    "filter": {
        "placeholder": {
            "file_number": "Filtrer par n° dossier",
            "label": "Filtre par libellé TPE",
            "card_type": "Filtre par émetteur",
            "pan": "Filtre par N° de carte"
        }
    },
    "history": {
        "empty_results": "Aucun résultat d'historique trouvé"
    },
    "status": {
        "OPENED": "Ouvert",
        "CLOSED_WITH_DEBIT": "Fermé avec débit",
        "CLOSED_NO_DEBIT": "Fermé sans débit",
        "CLOSED_EXPIRED": "Fermé expiré",
        "ERROR_INITIALIZATION": "Erreur ouverture",
        "UNKNOWN": "Inconnu"
    },
    "event_type": {
        "PREAUTHORIZATION": {
            "name": "Ouverture de dossier",
            "success": "Pré-autorisation acceptée",
            "error": "Pré-autorisation refusée"
        },
        "PREAUTHORIZATION_CANCELLATION": {
            "name": "Ouverture de dossier",
            "success": "Dossier annulé",
            "error": "Dossier annulé"
        },
        "DOCUMENT_REQUEST": {
            "name": "Demande de renseignement",
            "success": "Demande de renseignement acceptée",
            "error": "Demande de renseignement refusée"
        },
        "ADDITIONAL_INVOICE": {
            "name": "Facture complémentaire",
            "success": "Facture complémentaire acceptée",
            "error": "Facture complémentaire refusée"
        },
        "PAYMENT": {
            "name": "Clôture de dossier",
            "success": "Clôture avec débit",
            "error": "Clôture sans débit",
            "expired": "Dossier expiré"
        },
        "REMOTE_COLLECTION": {
            "name": "Remis en banque",
            "success": "",
            "error": ""
        },
        "UNKNOWN": {
            "name": "Inconnu",
            "success": "Aucune information disponible.",
            "error": "Aucune information disponible."
        }
    }
}